<script lang="ts">
    import { Navbar, NavUl } from "flowbite-svelte";
    import posthog from "posthog-js";
    import SidebarButton from "../sidebar/SidebarButton.svelte";
    import { State } from "../state.svelte.js";
    import { Helper } from "../helpers";
    import CustomLi from "./CustomLi.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";
    import ResetAllModal from "./ResetAllModal.svelte";
    import type { FixedNavbarType } from "../types";
    import { twMerge } from "tailwind-merge";
    import { BellOutline, BellRingOutline } from "flowbite-svelte-icons";

    const themeName = $derived(State.options.theme.toString()[0].toUpperCase() + State.options.theme.toString().slice(1).toLowerCase());

    let resetModalIsOpen: boolean = $state(false);

    function openDeleteModal() {
        resetModalIsOpen = true;
    }

    function closeDeleteModal() {
        resetModalIsOpen = false;
    }

    function resetAll() {
        posthog.capture('all_data_reset');
        Helper.resetChecklistAndCounter();
    }

    const FixedNavbar = Navbar as typeof FixedNavbarType;

    const defaultUlClass= "flex flex-col p-4 mt-4 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:text-sm md:font-medium";

</script>

<ResetAllModal bind:isOpen={resetModalIsOpen} close={closeDeleteModal} reset={resetAll}/>

<div class="relative px-8">
    <FixedNavbar fluid={true}
                 class="hidden v2xs:!block min-h-[45px] py-0 vmd:py-2.5 h-auto px-2 sm:px-4 fixed w-full z-20 top-0 start-0 bg-gray-50 black:bg-gray-950 frappe:bg-ctp-crust frappe:text-ctp-subtext0"
                 navContainerClass="h-full overflow-y-hidden"
                 color="none">
        <div>
            <SidebarButton/>
        </div>

        <NavUl ulClass={twMerge(defaultUlClass, "p-0 px-4 vsm:py-4 vsm:px-4")}>
            <CustomLi
                    style="color: {Helper.percentageToHexColor(State.percentChecklistItemsComplete)}">{State.percentChecklistItemsComplete}
                % Complete
            </CustomLi>

            <CustomLi>
                No Sleep {State.noSleepIsEnabled ? "Enabled" : "Disabled"}
            </CustomLi>

            <CustomLi class="cursor-pointer flex items-center justify-center gap-2"
                      onClick={() => State.options.darNotifications = !State.options.darNotifications}>

                {#if State.options.darNotifications}
                    <BellRingOutline class="w-5 h-5"/>
                {:else}
                    <BellOutline class="w-5 h-5"/>
                {/if}

                DAR Notifications {State.options.darNotifications ? "Enabled" : "Disabled"}</CustomLi>
            <CustomLi class="cursor-pointer"
                      onClick={() => State.options.theme = State.options.theme === "black" ? "light" : State.options.theme === "frappe" ? "black" : "frappe"}
            >Theme: {themeName}</CustomLi>
            <CustomLi>
                <ColoredButton vScale={true} color="red" onclick={openDeleteModal}>Reset All</ColoredButton>
            </CustomLi>
        </NavUl>
    </FixedNavbar>
</div>
